
import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TimeSlot from '@/common/TimeSlot.js'
import { TransTopReq } from '@/api/admin/risk'
@Component
export default class OperationLog extends Vue {
    logRouteList = []
    time_date = TimeSlot.today.value()
    shortcutDate = {
        disabledDate(date) {
            return date && date.valueOf() > Date.now()
        },
        shortcuts: [TimeSlot.yestoday, TimeSlot.today, TimeSlot.recentWeek, TimeSlot.recentMonth, TimeSlot.recentThreeMonth]
    }
    searchData = {
        platform: 0,
        app_id: 0,
        pageSizes: [15, 30, 45, 60],
        page: 1, // 默认第一页
        limit: 15, // 默认每页20条
        pageTotal: 0,
        stime: '',
        etime: '',
        opt_platform: null,
        opt_ip: '',
        opted_id: null,
        opt_account: '',
        device_id: '',
        opt_id: null,
        opt_type: '',
        user_id: null,
        phone_code: '',
        phone: '', //手机号
        tableData: [],
        columns: [
            // 表头文字
            { type: 'index', align: 'center', minWidth: 60 },
            {
                title: 'App信息',
                key: 'app_id',
                align: 'center',
                minWidth: 100,
                render: (h, params) => {
                    let str = params.row.app_name + '(' + params.row.app_id + ')'
                    return h('span', str)
                }
            },
            { title: '账户角色', key: 'role_id', align: 'center', minWidth: 80 },
            { title: '操作接口', key: 'route', align: 'center', minWidth: 150 },
            { title: '操作人ID', key: 'user_id', align: 'center', minWidth: 100 },
            { title: '操作人账户', key: 'username', align: 'center', minWidth: 100 },
            { title: '操作对象', key: 'opted_id', align: 'center', minWidth: 100 },
            { title: '操作时间', key: 'create_time', align: 'center', minWidth: 100 },
            { title: '操作人ip', key: 'ip_address', align: 'center', minWidth: 150 },
            { title: '操作描述', key: 'description', align: 'center', minWidth: 300 }
        ]
    }

    getAdminLog(num?) {
        if (!this.time_date[0]) {
            return this.$Message.error('请选择时间')
        }
        if (num) {
            this.searchData.page = 1
        }
        let param = {
            mod: 'root',
            platid: this.searchData.platform,
            app_id: this.searchData.app_id,
            param: {
                _mod: 'manager',
                _func: 'GetAdminLog',
                _param: {
                    page: this.searchData.page,
                    limit: this.searchData.limit,
                    stime: Math.round(this.time_date[0].getTime() / 1000),
                    etime: Math.round(this.time_date[1].getTime() / 1000 + 24 * 60 * 60 - 1),
                    app_id: Number(this.searchData.app_id),
                    opt_ip: this.searchData.opt_ip,
                    opted_id: Number(this.searchData.opted_id),
                    opt_id: Number(this.searchData.opt_id),
                    opt_account: this.searchData.opt_account,
                    opt_type: this.searchData.opt_type
                }
            }
        }

        TransTopReq(param).then((res) => {
            this.searchData.tableData = res._param.list || []
            this.searchData.pageTotal = res._param.total * 1
        })
    }
    //分页
    pageChange(num) {
        this.searchData.page = num
        this.getAdminLog()
    }
    Percentchange(num) {
        this.searchData.limit = num
        this.searchData.page = 1
        this.getAdminLog()
    }
    getLogRoutes() {
        if (!this.searchData.app_id) return
        let param = {
            mod: 'root',
            platid: this.searchData.platform,
            app_id: this.searchData.app_id,
            param: {
                _mod: 'manager',
                _func: 'GetLogRoutes',
                _param: {
                    app_id: Number(this.searchData.app_id),
                    type: 0
                }
            }
        }
        TransTopReq(param).then((res) => {
            this.logRouteList = []
            let data = res._param.new_data || {}

            data.forEach((res) => {
                ;(this.logRouteList as any).push({ route_key: res, rout_value: res })
            })
        })
    }

    created() {
        // this.getLogRoutes()
        // this.getAdminLog()
    }
}
